module.exports = __webpack_public_path__ + "img/CS-Lite-Vol_SpareA_1.23a13619.jpg";